import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

export async function getLogAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "action/get-logs", data, {
    headers: {
      Authorization: token,
    },
  });
}
